// extracted by mini-css-extract-plugin
module.exports = {"panel":"index-panel-14cbC","header":"index-header-3eMw8","close":"index-close-3n_87","iframe":"index-iframe-3z7we"};